import { render } from "./PolygonWidget.vue?vue&type=template&id=ea614778"
import script from "./PolygonWidget.vue?vue&type=script&lang=js"
export * from "./PolygonWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__